<template>
    <!-- 手机余额明细 -->
    <ZhaiHead></ZhaiHead>

    <div class="container-fluid zhu px-0">
        <div class="row shengse">
            <!-- 顶部（保留） -->
            <div class="dixian px-4 py-2 top-bar">
                <div class="promo-title" @click="goBack">
                    <i class="fa fa-bullhorn"></i>推广中心
                </div>

                <div class="top-center-title" @click="goBalanceDetails">余额明细</div>

                <div class="top-right" @click="goMyWallet">
                    钱包 <span class="arrow">›</span>
                </div>
            </div>

            <!-- ✅ 红色区域以下：Tab + 明细列表 -->
            <div class="balance-body">
                <!-- Tabs -->
                <div class="balance-tabs">
                    <div
                            class="tab-item"
                            :class="{ active: activeTab === 'all' }"
                            @click="changeTab('all')"
                    >
                        全部
                    </div>

                    <div class="tab-split"></div>

                    <div
                            class="tab-item"
                            :class="{ active: activeTab === 'out' }"
                            @click="changeTab('out')"
                    >
                        支出
                    </div>

                    <div class="tab-split"></div>

                    <div
                            class="tab-item"
                            :class="{ active: activeTab === 'in' }"
                            @click="changeTab('in')"
                    >
                        收入
                    </div>

                    <div class="tab-split"></div>

                    <!-- ✅ 提现：点击跳转到 /WithdrawalDetails -->
                    <div class="tab-item withdraw-tab" @click="goWithdrawalDetails">
                        提现 <span class="tab-arrow">›</span>
                    </div>
                </div>

                <!-- ✅ 明细列表（分页后的列表） -->
                <div class="detail-list" ref="listWrap" v-if="pagedList.length > 0">
                    <div
                            class="detail-item"
                            v-for="item in pagedList"
                            :key="item.id"
                    >
                        <div class="detail-left">
                            <div class="detail-title">{{ item.title }}</div>
                            <div class="detail-time">{{ item.time }}</div>
                        </div>

                        <div class="detail-right">
                            <div
                                    class="detail-money"
                                    :class="{
                                    plus: item.amount > 0,
                                    minus: item.amount < 0
                                }"
                            >
                                {{ formatMoney(item.amount) }}
                            </div>
                            <div class="detail-type">{{ item.typeText }}</div>
                        </div>
                    </div>

                    <!-- ✅ 总页数 > 1 才展示分页器（参考 WithdrawalDetails） -->
                    <div class="pager-wrap" v-if="totalPages > 1">
                        <div class="pager">
                            <!-- 上一页 -->
                            <button
                                    class="pager-btn"
                                    :disabled="page === 1 || pageChanging"
                                    @click="goPage(page - 1)"
                            >
                                «
                            </button>

                            <!-- 首页 -->
                            <button
                                    class="pager-btn"
                                    :class="{ active: page === 1 }"
                                    :disabled="pageChanging"
                                    @click="goPage(1)"
                            >
                                1
                            </button>

                            <!-- 中间动态 -->
                            <template v-if="totalPages >= 3">
                                <template v-if="page > 1 && page < totalPages">
                                    <button class="pager-btn dots" disabled>…</button>

                                    <button class="pager-btn active" disabled>
                                        {{ page }}
                                    </button>

                                    <button class="pager-btn dots" disabled>…</button>
                                </template>

                                <template v-else>
                                    <button class="pager-btn dots" disabled>…</button>
                                </template>
                            </template>

                            <!-- 末页 -->
                            <button
                                    class="pager-btn"
                                    :class="{ active: page === totalPages }"
                                    :disabled="pageChanging"
                                    @click="goPage(totalPages)"
                            >
                                {{ totalPages }}
                            </button>

                            <!-- 下一页 -->
                            <button
                                    class="pager-btn"
                                    :disabled="page === totalPages || pageChanging"
                                    @click="goPage(page + 1)"
                            >
                                »
                            </button>
                        </div>

                        <div class="pager-loading" v-if="pageChanging">加载中…</div>
                    </div>
                </div>

                <!-- 空状态（无数据） -->
                <div class="end-line" v-else>
                    <span class="end-text">我是有底线的</span>
                </div>
            </div>
        </div>
    </div>

    <ZhaiFoot></ZhaiFoot>
</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";
    import http from "@/utils/http";

    export default {
        name: "MBalanceDetails",
        components: { ZhaiHead, ZhaiFoot },

        data() {
            return {
                API_BALANCE_DETAIL: "/platform/withdraw/balanceDetail",

                // Tab：all / out / in（提现跳转页）
                activeTab: "all",

                // ✅ 与 PC 对齐：加载态 / 错误态
                loading: true,
                pageChanging: false,
                error: "",

                // ✅ 与 PC 对齐：后端分页参数
                page: 1,
                pageSize: 8,
                total: 0,

                // ✅ 接口返回覆盖这里（当前页数据）
                detailList: [],

                // ✅ 可选：更稳的 userId（同 PC）
                currentUserId: null,
            };
        },

        computed: {
            // ✅ 总页数来自后端 total（与 PC 一致）
            totalPages() {
                const t = Number(this.total || 0);
                const s = Number(this.pageSize || 10);
                return Math.max(1, Math.ceil(t / s));
            },

            /**
             * ✅ 兼容你现有模板：
             * - 以前是前端全量列表 + slice 分页
             * - 现在对齐 PC：detailList 已是“当前页列表”
             * 这里做一个兼容：如果后端已经分页返回（常见就是 list<=pageSize），直接返回 detailList；
             * 如果某些环境仍返回全量，也能继续 slice。
             */
            pagedList() {
                const list = Array.isArray(this.detailList) ? this.detailList : [];
                if (list.length <= this.pageSize) return list;

                const start = (this.page - 1) * this.pageSize;
                const end = start + this.pageSize;
                return list.slice(start, end);
            },
        },

        // ✅ 路由守卫：未登录直接跳登录页（同 PC）
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // ✅ mounted 再兜一次（同 PC）
            const token = localStorage.getItem("token");
            if (!token) {
                if (this.$router) this.$router.replace("/login");
                else window.location.href = "/login";
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();

            await this.fetchList(true);
        },

        methods: {
            // ================== 更稳的 userId 获取（同 PC） ==================
            resolveUserIdSafe() {
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },

            // ================== 登录失效识别（同一套逻辑，避免漏判） ==================
            isAuthExpired(err, json) {
                const code = err?.response?.status;
                if (code === 401 || code === 403) return true;

                const s = json?.status;
                if (s === 401 || s === 403 || s === -1) return true;

                const msg = String(json?.msg || err?.message || "");
                if (/token|登录|未登录|过期|失效|unauthorized|forbidden/i.test(msg)) return true;

                return false;
            },

            redirectToLogin() {
                if (this.$router) this.$router.replace("/login");
                else window.location.href = "/login";
            },

            // ================== 跳转（保留你原来的） ==================
            goBack() {
                if (this.$router) this.$router.push("/Promotion");
                else window.location.href = "/Promotion";
            },

            goMyWallet() {
                if (this.$router) this.$router.push("/MyWallet");
                else window.location.href = "/MyWallet";
            },
            goBalanceDetails() {
                if (this.$router) this.$router.push("/BalanceDetails");
                else window.location.href = "/BalanceDetails";
            },

            goWithdrawalDetails() {
                if (this.$router) this.$router.push("/WithdrawalDetails");
                else window.location.href = "/WithdrawalDetails";
            },

            // ================== 切 Tab：与 PC 一致（重置 page 并拉取） ==================
            changeTab(tab) {
                if (this.activeTab === tab) return;
                this.activeTab = tab;
                this.page = 1;
                this.fetchList(true);
            },

            // ================== 翻页：与 PC 一致 ==================
            async goPage(p) {
                const pageNum = Number(p);
                if (!pageNum || pageNum < 1 || pageNum > this.totalPages) return;
                if (pageNum === this.page) return;
                if (this.loading || this.pageChanging) return;

                this.pageChanging = true;
                this.page = pageNum;
                await this.fetchList(false);
                this.pageChanging = false;

                // 回到顶部（保持你原本体验）
                this.$nextTick(() => {
                    const el = this.$refs.listWrap;
                    if (el) el.scrollTop = 0;
                });
            },

            // ================== ✅ 拉余额明细：完全对齐 PC 接口/参数/返回 ==================
            async fetchList(reset = false) {
                try {
                    if (reset) {
                        this.loading = true;
                        this.error = "";
                    } else {
                        this.error = "";
                    }

                    const params = {
                        tab: this.activeTab, // all / in / out
                        page: this.page,
                        pageSize: this.pageSize,
                    };

                    if (this.currentUserId) params.userId = this.currentUserId;

                    const res = await http.get(this.API_BALANCE_DETAIL, params);
                    const json = res && res.data ? res.data : null;

                    if (this.isAuthExpired(null, json)) {
                        this.redirectToLogin();
                        return;
                    }

                    if (!json || Number(json.status) !== 1) {
                        throw new Error((json && json.msg) || "加载失败");
                    }

                    const data = json.data || {};
                    this.total = Number(data.total || 0);
                    this.page = Number(data.page || this.page);
                    this.pageSize = Number(data.pageSize || this.pageSize);

                    // 后端 list 就是当前页数据
                    this.detailList = Array.isArray(data.list) ? data.list : [];
                } catch (e) {
                    // 401/403 等
                    if (this.isAuthExpired(e, null)) {
                        this.redirectToLogin();
                        return;
                    }

                    this.detailList = [];
                    this.total = 0;
                    this.error = e && e.message ? e.message : "网络异常，请稍后再试";
                } finally {
                    this.loading = false;
                }
            },

            // 金额显示：+xx.xx / -xx.xx（保留你的）
            formatMoney(val) {
                const num = Number(val || 0);
                const abs = Math.abs(num).toFixed(2);
                if (num > 0) return `+${abs}`;
                if (num < 0) return `-${abs}`;
                return "0.00";
            },
        },
    };
</script>

<style scoped>
    .fa {
        margin-right: 6px;
    }

    /* 页面容器（你原来的） */
    .zhu {
        margin-top: 80px;
        height: calc(100vh - 80px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    /* 顶部栏三列布局：左 中 右 */
    .top-bar {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }

    .top-center-title {
        justify-self: center;
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        color: #00c26f;
    }

    .top-right {
        justify-self: end;
        font-size: 14px;
        color: #00c26f;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .top-right:active {
        opacity: 0.7;
    }

    .promo-title {
        cursor: pointer;
        user-select: none;
        font-size: 16px;
        color: #333;
    }

    .promo-title:active {
        opacity: 0.7;
    }

    .arrow {
        font-size: 22px;
        color: #c9c9c9;
        margin-right: 0;
    }

    /* ================= 红色区域以下 ================= */
    .balance-body {
        flex: 1;
        background: #fff;
        display: flex;
        flex-direction: column;
    }

    /* Tabs 行 */
    .balance-tabs {
        display: flex;
        align-items: center;
        height: 48px;
        border-bottom: 1px solid #eee;
    }

    /* 每个 Tab */
    .tab-item {
        flex: 1;
        text-align: center;
        font-size: 16px;
        color: #111;
        position: relative;
        padding: 10px 0;
        cursor: pointer;
        user-select: none;
    }

    .tab-item.active {
        color: #ff4d4f;
    }

    .tab-item.active::after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 6px;
        transform: translateX(-50%);
        width: 26px;
        height: 3px;
        border-radius: 3px;
        background: #ff4d4f;
    }

    /* Tab 之间竖线 */
    .tab-split {
        width: 1px;
        height: 18px;
        background: #e9e9e9;
    }

    /* 提现 tab：显示右箭头，更像“跳转项” */
    .withdraw-tab {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
    }

    .tab-arrow {
        color: #c9c9c9;
        font-size: 20px;
        transform: translateY(-1px);
    }

    /* ================= 明细列表 ================= */
    .detail-list {
        flex: 1;
        overflow-y: auto;
        background: #fff;
    }

    /* 每一条 */
    .detail-item {
        display: flex;
        justify-content: space-between;
        padding: 14px 14px;
        border-bottom: 1px solid #f2f2f2;
    }

    .detail-left {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .detail-title {
        font-size: 16px;
        color: #111;
        font-weight: 600;
    }

    .detail-time {
        font-size: 12px;
        color: #9aa0a6;
    }

    .detail-right {
        text-align: right;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    .detail-money {
        font-size: 16px;
        font-weight: 700;
        color: #111;
    }

    /* 收入/支出颜色 */
    .detail-money.plus {
        color: #00c26f;
    }
    .detail-money.minus {
        color: #ff4d4f;
    }

    .detail-type {
        font-size: 12px;
        color: #9aa0a6;
    }

    /* ================= 空状态（中间线） ================= */
    .end-line {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9aa0a6;
        font-size: 16px;
    }

    .end-line::before,
    .end-line::after {
        content: "";
        height: 1px;
        width: 120px;
        background: #e5e5e5;
    }

    .end-text {
        padding: 0 14px;
    }

    /* ================= 分页器（参考 WithdrawalDetails） ================= */
    .pager-wrap {
        padding: 14px 0 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .pager {
        display: inline-flex;
        align-items: center;
        border-radius: 10px;
        overflow: hidden;
        border: 1px solid #e6e6e6;
        background: #fff;
    }
    .pager-btn {
        min-width: 34px;
        height: 32px;
        padding: 0 10px;
        border: 0;
        border-right: 1px solid #e6e6e6;
        background: #fff;
        color: #333;
        font-size: 18px;
        line-height: 32px;
        text-align: center;
        cursor: pointer;
        user-select: none;
    }
    .pager-btn:last-child {
        border-right: 0;
    }
    .pager-btn:disabled {
        opacity: 0.45;
        cursor: not-allowed;
    }
    .pager-btn.active {
        color: #00c26f;
        font-weight: 800;
        background: #f3fff8;
    }
    .pager-btn.dots {
        cursor: default;
        font-weight: 700;
    }
    .pager-btn:active:not(:disabled):not(.dots) {
        opacity: 0.75;
    }
    .pager-loading {
        margin-top: 8px;
        font-size: 12px;
        color: #9a9a9a;
    }
</style>
